<template>
    <router-view />
</template>

<script>
export default {
    name: "Izin"
}
</script>

<style scoped></style>